import { useUserStore } from '@/stores/user_store';
import { useWorkspace } from './workspace_resource';
import type { WorkspaceResponse } from './workspaces_resource';

export type WorkspaceAccessLevel = 'write' | 'operator' | 'read' | 'none';

export function useWorkspaceAccess(
  workspace: WorkspaceResponse | null | undefined
): WorkspaceAccessLevel {
  const isAdmin = useUserStore((s) => s.isAdmin);
  const groups = useUserStore((s) => s.groups);
  const forcedRole = useUserStore((s) => s.forcedRole);

  if (!workspace) return 'none';
  if (forcedRole) return forcedRole;
  if (isAdmin) return 'write';

  if (workspace.adGroupUUID && groups.includes(workspace.adGroupUUID)) return 'write';
  if (workspace.operatorAdGroupUUID && groups.includes(workspace.operatorAdGroupUUID))
    return 'operator';
  if (workspace.readonlyAdGroupUUID && groups.includes(workspace.readonlyAdGroupUUID))
    return 'read';

  return 'none';
}

export function useCanWrite(workspace: WorkspaceResponse | null | undefined): boolean {
  return useWorkspaceAccess(workspace) === 'write';
}

export function useCanOperate(workspace: WorkspaceResponse | null | undefined): boolean {
  const level = useWorkspaceAccess(workspace);
  return level === 'write' || level === 'operator';
}

export function useCanWriteById(workspaceId: number | null | undefined): boolean {
  const { data } = useWorkspace(workspaceId);
  return useCanWrite(data);
}

export function useCanOperateById(workspaceId: number | null | undefined): boolean {
  const { data } = useWorkspace(workspaceId);
  return useCanOperate(data);
}
